{
  "anchor": {
    "gutter": {
      "$type": "number",
      "$value": 2
    }
  },
  "content": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{border.radius.md}"
      }
    }
  },
  "disabled": {
    "opacity": {
      "$type": "number",
      "$value": 60
    }
  },
  "focus": {
    "ring": {
      "width": {
        "$type": "number",
        "$value": 1
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "offset": {
        "$type": "number",
        "$value": 2
      }
    }
  },
  "form": {
    "field": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.xl}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": 0
          },
          "color": {
            "$type": "color",
            "$value": "rgba(0, 0, 0, 0.0000)"
          },
          "offset": {
            "$type": "number",
            "$value": 0
          }
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "y": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "sm": {
        "font": {
          "size": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "padding": {
          "x": {
            "$type": "number",
            "$value": "{scale.0-625}"
          },
          "y": {
            "$type": "number",
            "$value": "{scale.0-375}"
          }
        }
      },
      "lg": {
        "font": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-125}"
          }
        },
        "padding": {
          "x": {
            "$type": "number",
            "$value": "{scale.0-875}"
          },
          "y": {
            "$type": "number",
            "$value": "{scale.0-625}"
          }
        }
      }
    }
  },
  "icon": {
    "size": {
      "$type": "number",
      "$value": "{scale.1}"
    }
  },
  "list": {
    "gap": {
      "$type": "number",
      "$value": 2
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "y": {
        "$type": "number",
        "$value": "{scale.0-25}"
      }
    },
    "header": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "right": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "option": {
      "group": {
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-75}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      }
    }
  },
  "navigation": {
    "item": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      }
    },
    "submenu": {
      "label": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-75}"
          }
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        }
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": 2
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-25}"
        }
      }
    }
  },
  "overlay": {
    "select": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.xl}"
        }
      }
    },
    "popover": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-75}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.md}"
        }
      }
    },
    "modal": {
      "padding": {
        "$type": "number",
        "$value": "{scale.1-25}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.xl}"
        }
      }
    },
    "title": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      }
    }
  },
  "primary": {
    "50": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.50}"
    },
    "100": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.100}"
    },
    "200": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.200}"
    },
    "300": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.300}"
    },
    "400": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.400}"
    },
    "500": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.500}"
    },
    "600": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.600}"
    },
    "700": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.700}"
    },
    "800": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.800}"
    },
    "900": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.900}"
    },
    "950": {
      "$type": "color",
      "$value": "{ods.core-colours.brand-light.950}"
    }
  }
}
